import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { DataProvider } from "@/context/DataContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Entries from "@/pages/Entries";
import Invoices from "@/pages/Invoices";
import Masters from "@/pages/Masters";
import Sheets from "@/pages/Sheets";
import Reminders from "@/pages/Reminders";
import Settings from "@/pages/Settings";
import Monthly from "@/pages/Monthly";
import Validation from "@/pages/Validation";
import Team from "@/pages/Team";
import Expenses from "@/pages/Expenses";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-slate-500">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return (
    <DataProvider>
      <Layout>{children}</Layout>
    </DataProvider>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/entries" element={<Protected><Entries /></Protected>} />
            <Route path="/invoices" element={<Protected><Invoices /></Protected>} />
            <Route path="/masters" element={<Protected><Masters /></Protected>} />
            <Route path="/sheets" element={<Protected><Sheets /></Protected>} />
            <Route path="/reminders" element={<Protected><Reminders /></Protected>} />
            <Route path="/monthly" element={<Protected><Monthly /></Protected>} />
            <Route path="/validation" element={<Protected><Validation /></Protected>} />
            <Route path="/team" element={<Protected><Team /></Protected>} />
            <Route path="/expenses" element={<Protected><Expenses /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
